import React from 'react';
import Link from '@mui/material/Link';

export default function Footer() {
  return <footer style={{ borderTop: '1px solid #ddd', padding: '2px 8px', display: 'flex', flexDirection: 'row', gap: '12px' }}>
    <Link href="/regulamin_2023.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#9B231F' }}>Regulamin</Link>
    <Link href="/polityka_2023.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#9B231F' }}>Polityka prywatności</Link>
  </footer>;
}
